/* ltt-cart-promo.js — discount-code entry inside the cart drawer.

   WHY A REDIRECT AND NOT A FETCH: Shopify's Cart AJAX API has no endpoint for
   applying a discount. `/cart/update.js` takes attributes and notes, not codes.
   The only supported way to put a code on the session is to visit
   `/discount/<CODE>`, which applies it and then follows `?redirect=`. So the
   form navigates — deliberately — and comes back to the cart with the code
   live on the session and visible in `cart.discount_applications`.

   Delegated at document level: the drawer's markup is replaced wholesale on
   every cart change, so anything bound per-element would be lost. */
(function () {
  'use strict';
  if (window.lttCartPromoBound) return;
  window.lttCartPromoBound = true;

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-ltt-promo-form]')) return;
    event.preventDefault();

    var input = form.querySelector('[data-ltt-promo-input]');
    var error = form.querySelector('[data-ltt-promo-error]');
    var code = (input && input.value ? input.value : '').trim();

    if (!code) {
      if (input) input.focus();
      return;
    }

    // A code is a URL path segment here, so anything that could break out of
    // it is rejected rather than escaped — a slash would silently retarget the
    // navigation to a different Shopify route.
    if (/[\/?#\s]/.test(code)) {
      if (error) {
        error.textContent = error.dataset.invalidMessage || '';
        error.hidden = false;
      }
      if (input) input.focus();
      return;
    }

    if (error) error.hidden = true;
    form.setAttribute('aria-busy', 'true');

    var back = form.dataset.redirect || '/cart';
    window.location.href =
      '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  });
})();
